export const isLimitedRecurringItem = (item) => Boolean(item.recurring &&
    typeof item.recurring_count === 'number' &&
    item.recurring_count > 1);
export const isLifetimeRecurringItem = (item) => Boolean(item.recurring && !item.recurring_count);
//# sourceMappingURL=recurringItem.js.map